import { z } from 'zod';

export const createEntitySchema = z.object({
  code: z.string()
    .min(1, 'Code is required')
    .max(10, 'Code must be 10 characters or less')
    .regex(/^[A-Za-z]+$/, 'Code must contain only letters'),
  name: z.string().min(1, 'Name is required'),
  country: z.string().optional(),
  taxId: z.string().optional(),
  defaultCurrency: z.string()
    .max(3, 'Currency code must be 3 characters or less')
    .regex(/^[A-Za-z]*$/, 'Currency must contain only letters')
    .optional()
    .or(z.literal('')),
});

export type CreateEntityFormData = z.infer<typeof createEntitySchema>;
